import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { HttpClient , HttpParams} from '@angular/common/http';
import { Router } from '@angular/router';
@Component({
  selector: 'app-register-summer-camp',
  templateUrl: './register-summer-camp.component.html',
  styleUrls: ['./register-summer-camp.component.scss']
})
export class RegisterSummerCampComponent implements OnInit {

  //add user form start
  registerForm: FormGroup;
  submitted = false;
  router: any;
  key:any;
  constructor( public fb: FormBuilder, private http: HttpClient, private _router: Router){
    this.registerForm = this.fb.group({ 
      studentName: ['', [Validators.required]],
      age: ['', [Validators.required]],
      batch: ['',],
      blood_group: ['',],
      instituteName: ['', [Validators.required]],
      address: ['',[Validators.required]],
      zip: ['',[Validators.required]],
      parent_mobileNo: ['',[Validators.required]],
      stud_email: ['',[Validators.required]],
      parent_email: ['',[Validators.required]],
      first_guardian: ['',[Validators.required]],
      first_cell_phone: ['',[Validators.required]],
      first_work_place: ['',[Validators.required]],
      first_work_phone: ['',[Validators.required]],
      second_guardian: ['',],
      sec_cell_phone: ['',],
      sec_work_place: ['',],
      sec_work_phone: ['',],
      emr_contact: ['',[Validators.required]],
      relationship: ['',[Validators.required]],
      category_sport: ['',[Validators.required]],
      pick_candidate_one : ['',],
      pick_phone_one : ['',],
      pick_candidate_two : ['',],
      pick_phone_two : ['',],
      pick_candidate_three : ['',],
      pick_phone_three  : ['',],
      pick_candidate_four : ['',],
      pick_phone_four : ['',],
      pick_candidate_five  : ['',], 
      pick_phone_five : ['',],
      message : ['',]
    })
  }
  
  get f() { return this.registerForm.controls;}
  //Add user form actions

  

  submitForm() {
    this.submitted = true;
    // stop here if form is invalid
    if (this.registerForm.invalid) {
        return;
    }
  
  var formData: any = new FormData();
  formData.append("studentName", this.registerForm.value.studentName);
  formData.append("age", this.registerForm.value.age);
  formData.append("batch", this.registerForm.value.batch);
  formData.append("blood_group", this.registerForm.value.blood_group);
  formData.append("instituteName", this.registerForm.value.instituteName);
  
  formData.append("address", this.registerForm.value.address);
  formData.append("zip", this.registerForm.value.zip);
  formData.append("parent_mobileNo", this.registerForm.value.parent_mobileNo);
  formData.append("stud_email", this.registerForm.value.stud_email);
  formData.append("parent_email", this.registerForm.value.parent_email);
  formData.append("first_guardian", this.registerForm.value.first_guardian);
  formData.append("first_cell_phone", this.registerForm.value.first_cell_phone);
  formData.append("first_work_place", this.registerForm.value.first_work_place);
  formData.append("first_work_phone", this.registerForm.value.first_work_phone); 
  formData.append("second_guardian", this.registerForm.value.second_guardian);
  formData.append("sec_cell_phone", this.registerForm.value.sec_cell_phone);
  formData.append("sec_work_place", this.registerForm.value.sec_work_place);
  formData.append("sec_work_phone", this.registerForm.value.sec_work_phone);
  formData.append("emr_contact", this.registerForm.value.emr_contact);
  formData.append("relationship", this.registerForm.value.relationship);
  formData.append("category_sport", this.registerForm.value.category_sport);
  formData.append("pick_candidate_one", this.registerForm.value.pick_candidate_one);
  formData.append("pick_phone_one", this.registerForm.value.pick_phone_one);
  formData.append("pick_candidate_two", this.registerForm.value.pick_candidate_two);
  formData.append("pick_phone_two", this.registerForm.value.pick_phone_two);
  formData.append("pick_candidate_three", this.registerForm.value.pick_candidate_three);
  formData.append("pick_phone_three", this.registerForm.value.pick_phone_three);
  formData.append("pick_candidate_four", this.registerForm.value.pick_candidate_four);
  formData.append("pick_phone_four", this.registerForm.value.pick_phone_four);
  formData.append("pick_candidate_five", this.registerForm.value.pick_candidate_five);
  formData.append("pick_phone_five", this.registerForm.value.pick_phone_five);
  formData.append("message", this.registerForm.value.message);
  console.log(formData);
    
  this.http.post('https://ghrscf.com/includes/summer-camp.php', formData).subscribe(
    (response: any) => console.log(response),
    (error: any) => console.log(error)
  );
  //this.router.navigate(['/demo']);
  //this._router.navigateByUrl('/thank-you');
 //this._router.navigateByUrl('/payment-form')
}


  ngOnInit(): void {
  }

}
